import { itemIsGroup } from './tree-type';
import { getIn } from 'immutable';
import { pathForSetIn } from './path-for-set-in';
/**
 * @function findGroupForDevice - Ищем в какой группе устройство
 * @param device - устройство или его номер
 * @param device_tree - дерево групп
 * @return {
    name: string;
    path: number[];
} здесь путь до устройства!!! Путь до группы .slice(0,-1)
 */
export const findGroupForDevice = (device, device_tree) => {
    if (device_tree == null)
        return { name: 'Нет группы', path: [], id: '-1' };
    const dev_id = typeof device === 'number' ? device : device.id;
    const walkInChildren = (device_id, device_tree_children, counter = 0) => {
        for (let i = 0; i < device_tree_children.length; i++) {
            const node = device_tree_children[i];
            if ('ZontId' in node && node.ZontId === dev_id)
                return { found_path: [i], counter };
            counter++;
            if ('Children' in node && node.Children) {
                const result = walkInChildren(dev_id, node.Children, counter);
                if (result.found_path)
                    return { found_path: [i, ...result.found_path], counter };
                counter = result.counter;
            }
        }
        return { counter };
    };
    const { found_path } = walkInChildren(dev_id, device_tree);
    //Если только 1 значение нашлось, значит нет его ни в одной группе
    if (!found_path)
        return { name: 'Нет группы', path: [], id: '-1' };
    if (found_path.length === 1)
        return { name: 'Нет группы', path: found_path, id: '-1' };
    //Берём родителя из найденного пути
    const parent_node = getIn(device_tree, pathForSetIn(found_path.slice(0, -1)).without_children, null);
    if (parent_node == null)
        return { name: 'Нет группы', path: [], id: '-1' };
    return { name: parent_node.Name, path: found_path, id: parent_node.id };
};
// export const devicesInGroup = (items: CustomTreeItem[]): [{id: number}] =>
//     items
//         .flatMap((item: CustomTreeItem) => {
//             if ('children' in item) return devicesInGroup(item.children);
//             if ('device' in item) return {id: item.device.id};
//             return null;
//         })
//         .filter((item) => item != null);
export const countDevicesInGroup = (items) => {
    let count = 0;
    items.forEach((item) => {
        if (itemIsGroup(item))
            count += countDevicesInGroup(item.children);
        else
            count++;
    });
    return count;
};
//Возвращает массив с ID устройств
export const selectDevicesInGroup = (items) => {
    // const selectedDevices = devicesInGroup(items);
    // console.log(selectedDevices);
    return null;
};
export function getIndexesFromDeviceTree(device_tree) {
    if (device_tree == null)
        return null;
    const item_with_path = [];
    for (let i = 0; i < device_tree.length; i++) {
        const node = device_tree[i];
        if (('ZontId' in node && node.ZontId) || ('Reg' in node && node.Reg))
            item_with_path.push({ item: node, path: [i] });
        if ('Children' in node && node.Children) {
            item_with_path.push({ item: node, path: [i] });
            const result = getIndexesFromDeviceTree(node.Children);
            if (result != null)
                item_with_path.push(...result.map((children_item) => ({
                    item: children_item.item,
                    path: [i, ...children_item.path],
                })));
        }
    }
    return item_with_path;
}
